module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-users-container"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('h1', [_vm._v("Användare")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "add-user-section"
  }, [_c('h3', [_vm._v("Lägg till ny administratör")]), _vm._v(" "), _c('form', {
    staticClass: "add-user-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "new-email"
    }
  }, [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    attrs: {
      "type": "email",
      "id": "new-email",
      "placeholder": "namn@branas.se",
      "required": ""
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Lägg till")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "users-list-section"
  }, [_c('h3', [_vm._v("Befintliga användare")]), _vm._v(" "), _c('table', {
    staticClass: "users-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', {
      staticClass: "email-cell"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('span', {
      class: 'role-badge ' + user.role
    }, [_vm._v(_vm._s(user.role))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(user.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(user.last_login_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(user.last_activity_at)))]), _vm._v(" "), _c('td', [(user.email !== _vm.currentUserEmail && user.role !== 'superadmin') ? _c('button', {
      staticClass: "btn btn-delete",
      on: {
        "click": function($event) {
          return _vm.deleteUser(user)
        }
      }
    }, [_vm._v("\n                Ta bort\n              ")]) : (user.email === _vm.currentUserEmail) ? _c('span', {
      staticClass: "self-label"
    }, [_vm._v("Du")]) : _c('span', {
      staticClass: "self-label"
    }, [_vm._v("Skyddad")])])])
  }), _vm._v(" "), (_vm.users.length === 0) ? _c('tr', [_c('td', {
    staticClass: "empty-cell",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Inga användare hittades.")])]) : _vm._e()], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("E-post")]), _vm._v(" "), _c('th', [_vm._v("Roll")]), _vm._v(" "), _c('th', [_vm._v("Skapad")]), _vm._v(" "), _c('th', [_vm._v("Senaste inloggning")]), _vm._v(" "), _c('th', [_vm._v("Senaste aktivitet")]), _vm._v(" "), _c('th', [_vm._v("Åtgärd")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45e09e99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Users.vue
// module id = 981
// module chunks = 0